import { Component } from '@angular/core';

@Component({
    selector: 'app-ots-contract-container',
    template: `
        <app-ots-contract-container-component energySuggestionsRoute="../eots/energy-suggestions"></app-ots-contract-container-component>
    `,
    styles: [],
})
export class ContractContainer {}
